import React from "react";
import {AppMarketsAutocomplete} from "../../../Autocomplete";
import {BACKEND_APIS} from "@constants";
import { translateCountryName } from "@ui-seeker/utils"
import { FlagsIconSeeker } from "@ui-seeker/core"
import {Box, Typography} from "@mui/material";

const MARKET_ALIASES = { 'uk': 'gb' }

const filterMarketOptions = (options, { inputValue }) => {
    const input = inputValue.toLowerCase()
    const alias = MARKET_ALIASES[input]
    return options
        .filter(({ label }) => {
            const code = label?.toLowerCase()
            const name = translateCountryName(label)?.toLowerCase()
            return code?.includes(input) || name?.includes(input) || (alias && code?.includes(alias))
        })
        .sort((a, b) => translateCountryName(a.label)?.localeCompare(translateCountryName(b.label)))
}

export default function AppCommonFiltersMarkets({...props}) {

    return <AppMarketsAutocomplete
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/markets`}
        filterOptions={filterMarketOptions}
        formatOptionLabel={({value, label}) => <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 1}} >
            <Typography>{translateCountryName(label)}</Typography>
            <FlagsIconSeeker countryName={value} />
        </Box>}
        {...props}
    />
}